<template>
  <div class="radioBtn">
    <img @click="clickHandler" v-if='value' src="../assets/svg/conCircle.svg" />
    <img @click="clickHandler" v-else src="../assets/svg/circle.svg" />
  </div>
</template>

<script>
export default {
  data () {
    return {
			
    }
  },
  props: {
		//是否选中
    value: {
      type: Boolean,
      default: false,
    }
  },
	methods: {
		goback() {
      this.$router.go(-1)
    },
		clickHandler(){
			this.$emit('changeValue')
		}
	},
	computed: {

	}
}
</script>

<style lang="less" scoped>
  @import "../assets/theme.less";
  .radioBtn{
    display: inline-flex;
    img{
      margin: auto 0;
      width:15px;
      height:15px;
    }
  }
</style>


// WEBPACK FOOTER //
// radioBtn.vue?4a7238b9